export default function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-teal-900 to-gray-900">
        <img 
          src="https://public.readdy.ai/ai/img_res/13d297202226188f433024360ed30d30.jpg"
          alt="Secure Network Background"
          className="w-full h-full object-cover opacity-30"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-8">
          <span className="text-white text-sm font-medium">Enterprise VPN Solutions</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Secure Your Digital<br />
          World With<br />
          Advanced VPN Technology
        </h1>

        <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          Experience military-grade encryption and lightning-fast connections with CAISA VPN.<br />
          Protect your privacy and browse anonymously from anywhere in the world.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={() => scrollToSection('contact')}
            className="px-8 py-4 bg-teal-500 text-white font-semibold rounded-full hover:bg-teal-600 hover:shadow-2xl hover:shadow-teal-500/50 transition-all transform hover:scale-105 whitespace-nowrap"
          >
            Start Free Trial
          </button>
          <button 
            onClick={() => scrollToSection('vpn-service')}
            className="px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-full hover:bg-white hover:text-gray-900 transition-all transform hover:scale-105 whitespace-nowrap"
          >
            Learn More
          </button>
        </div>

        <div className="mt-20">
          <img 
            src="https://readdy.ai/api/search-image?query=isometric%203D%20illustration%20of%20encrypted%20data%20flowing%20through%20secure%20VPN%20tunnels%20with%20floating%20lock%20icons%20shield%20symbols%20and%20network%20nodes%20in%20teal%20and%20cyan%20colors%20on%20transparent%20background%20showing%20digital%20security%20concept%20with%20geometric%20shapes%20and%20glowing%20connections&width=1200&height=800&seq=hero-illustration-001&orientation=landscape"
            alt="VPN Security Illustration"
            className="w-full max-w-4xl mx-auto"
          />
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}